/*
 * @Author: liujunhong
 * @Date: 2023/7/3
 * @Desc: 通用常量
 */

export const MAP_SITE_URL = {
  /**
   * 默认请求
   */
  API_BASE_URL: '',
  API_ACCOUNT_URL: '//accountv5.gyyx.cn',
  API_REG_URL: '//reg.gyyx.cn',
  API_SECURITY_URL: '//securityv5.gyyx.cn',
  DEFAULT_URL: '//we.gyyx.cn',
  WWW_URL: '//www.gyyx.cn',
  API_APIJ_URL: '//apij-helpv5.gyyx.cn',
  API_CLOUD_URL: '//apicloud.gyyx.cn',
  UPLOAD_URL:'//upload.gyyx.cn'
};
export const UPLOAD_BUSINESS = 'kf';
/**
 * 短信sourceType
 */
export const SEND_SMS_SOURCE_TYPE = {
  VERIFY_PHONE: 'VerifyOldMobilePhone',
  CHANGE_PHONE: 'ChangeMobilePhone',
};


/**
 * 结果
 */
export const RESPONSE_STATUS = {
  SUCCESS: 'SUCCESS',
  TOKEN_ERROR: 'TOKEN_ERROR',
};


export const SEND_VC_TYPE = {
  ACCOUNT: 'account',
  PHONE: 'phone',
};

export const BIND_PHONE_STATUS = {
  UNBIND: 'Unbind',
  BIND: 'Bind',
  AUTHING: 'Authing',
  FINISH: 'AuthFinish',
};

export const K_F_BID = 'mbtdjnju4ptk';